// extracted by mini-css-extract-plugin
module.exports = {"background":"_3O4AMQDJpbz808sxvNrtUI"};